import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const SAFETY_FAERS_LANG: {
  SAFETY_FAERS_TARGET_PRODUCT_SECTION_TITLE: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_COLUMN_NAME: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_COLUMN_FAERS_MAPPING: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_COLUMN_ACTIONS: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_ADD_BUTTON: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_EMPTY: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_ADD_SUCC: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_DELETE_SUCC: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_DELETE_CONFIRM_TITLE: MvnCodeFE;
  SAFETY_FAERS_TARGET_PRODUCT_DELETE_CONFIRM_DESCRIPTION: MvnCodeFE;

  SAFETY_FAERS_MAPPING_SEARCH_PLACEHOLDER: MvnCodeFE;
  SAFETY_FAERS_MAPPING_SEARCH_EMPTY: MvnCodeFE;
  SAFETY_FAERS_MAPPING_DRUG_REPORT_COUNT: MvnCodeFE;
  SAFETY_FAERS_MAPPING_DRUG_NO_REPORT_NOTICE: MvnCodeFE;
  SAFETY_FAERS_MAPPING_SET_BUTTON: MvnCodeFE;
  SAFETY_FAERS_MAPPING_EDIT_BUTTON: MvnCodeFE;
  SAFETY_FAERS_MAPPING_REMOVE_BUTTON: MvnCodeFE;
  SAFETY_FAERS_MAPPING_NOT_SET: MvnCodeFE;
  SAFETY_FAERS_MAPPING_SET_SUCC: MvnCodeFE;
  SAFETY_FAERS_MAPPING_EDIT_SUCC: MvnCodeFE;
  SAFETY_FAERS_MAPPING_REMOVE_SUCC: MvnCodeFE;
  SAFETY_FAERS_MAPPING_REMOVE_CONFIRM_TITLE: MvnCodeFE;
  SAFETY_FAERS_MAPPING_REMOVE_CONFIRM_DESCRIPTION: MvnCodeFE;

  SAFETY_FAERS_MAPPING_BATCH_RAN_NOTICE: MvnCodeFE;

  SAFETY_FAERS_CRITERIA_SECTION_TITLE: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_TYPE_EVANS: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_TYPE_CUSTOM: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_EVANS_DESCRIPTION: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_CUSTOM_PRR_THRESHOLD_LABEL: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_CUSTOM_ROR_THRESHOLD_LABEL: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_CUSTOM_CHI_SQUARE_THRESHOLD_LABEL: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_CUSTOM_CASE_COUNT_THRESHOLD_LABEL: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_MET: MvnCodeFE;
  SAFETY_FAERS_CRITERIA_NOT_MET: MvnCodeFE;

  SAFETY_FAERS_COMPARISON_PANEL_TITLE: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_AUTO_SNAPSHOT_NOTICE: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_CRITERIA_HEADER: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_TABLE_INTERNAL_HEADER: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_TABLE_FAERS_HEADER: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_TABLE_REPORT_COUNT: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_TABLE_PRR: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_TABLE_ROR: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_TABLE_CHI_SQUARE: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_HISTORY_TITLE: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_HISTORY_EMPTY: MvnCodeFE;
  SAFETY_FAERS_COMPARISON_HISTORY_BATCH_LABEL: MvnCodeFE;

  SAFETY_FAERS_SIGNAL_CHECK_PANEL_TITLE: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_MODE_MAPPED: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_MODE_DIRECT: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_MAPPED_PRODUCT_LABEL: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_DIRECT_SEARCH_PLACEHOLDER: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_DIRECT_SEARCH_EMPTY: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_REACTION: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_REPORT_COUNT: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_PRR: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_ROR: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_CHI_SQUARE: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_CRITERIA_COLUMN: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_RESULT_EMPTY: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_SAVE_BUTTON: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_SAVE_SUCC: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_HISTORY_TITLE: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_HISTORY_EMPTY: MvnCodeFE;
  SAFETY_FAERS_SIGNAL_CHECK_DRAWER_TRIGGER: MvnCodeFE;

  SAFETY_FAERS_ERROR_EXTERNAL_FETCH_FAILED: MvnCodeFE;
  SAFETY_FAERS_ERROR_GENERIC_RETRY: MvnCodeFE;

  SAFETY_FAERS_USER_JUDGMENT_DISCLAIMER: MvnCodeFE;
} = {
  SAFETY_FAERS_TARGET_PRODUCT_SECTION_TITLE: { ko: "분석 대상 자사 약물", en: "Target Products" },
  SAFETY_FAERS_TARGET_PRODUCT_COLUMN_NAME: { ko: "자사 약물명", en: "Product Name" },
  SAFETY_FAERS_TARGET_PRODUCT_COLUMN_FAERS_MAPPING: { ko: "FAERS 매핑", en: "FAERS Mapping" },
  SAFETY_FAERS_TARGET_PRODUCT_COLUMN_ACTIONS: { ko: "액션", en: "Actions" },
  SAFETY_FAERS_TARGET_PRODUCT_ADD_BUTTON: { ko: "약물 추가", en: "Add Product" },
  SAFETY_FAERS_TARGET_PRODUCT_EMPTY: { ko: "추가된 자사 약물이 없습니다.", en: "No target products added." },
  SAFETY_FAERS_TARGET_PRODUCT_ADD_SUCC: { ko: "자사 약물이 추가되었습니다.", en: "Target product added." },
  SAFETY_FAERS_TARGET_PRODUCT_DELETE_SUCC: { ko: "자사 약물이 삭제되었습니다.", en: "Target product deleted." },
  SAFETY_FAERS_TARGET_PRODUCT_DELETE_CONFIRM_TITLE: {
    ko: "자사 약물을 삭제하시겠습니까?",
    en: "Delete this target product?",
  },
  SAFETY_FAERS_TARGET_PRODUCT_DELETE_CONFIRM_DESCRIPTION: {
    ko: "이미 저장된 비교/시그널 체크 결과는 영향을 받지 않습니다.",
    en: "Existing comparison and signal-check results are not affected.",
  },

  SAFETY_FAERS_MAPPING_SEARCH_PLACEHOLDER: { ko: "외부 약물명 검색", en: "Search external drug" },
  SAFETY_FAERS_MAPPING_SEARCH_EMPTY: { ko: "검색 결과가 없습니다.", en: "No results found." },
  SAFETY_FAERS_MAPPING_DRUG_REPORT_COUNT: { ko: "FAERS 보고 {count}건", en: "{count} FAERS reports" },
  SAFETY_FAERS_MAPPING_DRUG_NO_REPORT_NOTICE: { ko: "빈도 확인 불가", en: "Frequency unavailable" },
  SAFETY_FAERS_MAPPING_SET_BUTTON: { ko: "매핑 설정", en: "Set Mapping" },
  SAFETY_FAERS_MAPPING_EDIT_BUTTON: { ko: "매핑 변경", en: "Edit Mapping" },
  SAFETY_FAERS_MAPPING_REMOVE_BUTTON: { ko: "매핑 해제", en: "Remove Mapping" },
  SAFETY_FAERS_MAPPING_NOT_SET: { ko: "매핑 없음", en: "Not mapped" },
  SAFETY_FAERS_MAPPING_SET_SUCC: { ko: "매핑이 설정되었습니다.", en: "Mapping set." },
  SAFETY_FAERS_MAPPING_EDIT_SUCC: { ko: "매핑이 변경되었습니다.", en: "Mapping updated." },
  SAFETY_FAERS_MAPPING_REMOVE_SUCC: { ko: "매핑이 해제되었습니다.", en: "Mapping removed." },
  SAFETY_FAERS_MAPPING_REMOVE_CONFIRM_TITLE: { ko: "매핑을 해제하시겠습니까?", en: "Remove this mapping?" },
  SAFETY_FAERS_MAPPING_REMOVE_CONFIRM_DESCRIPTION: {
    ko: "이미 저장된 비교/시그널 체크 결과는 영향을 받지 않습니다.",
    en: "Existing comparison and signal-check results are not affected.",
  },
  SAFETY_FAERS_MAPPING_BATCH_RAN_NOTICE: {
    ko: "배치가 수행된 후에는 매핑 정보를 변경할 수 없습니다.",
    en: "FAERS mapping cannot be changed after a batch has been run.",
  },

  SAFETY_FAERS_CRITERIA_SECTION_TITLE: { ko: "신호 판정 기준 (Criteria)", en: "Signal Criteria" },
  SAFETY_FAERS_CRITERIA_TYPE_EVANS: { ko: "Evans", en: "Evans" },
  SAFETY_FAERS_CRITERIA_TYPE_CUSTOM: { ko: "Custom", en: "Custom" },
  SAFETY_FAERS_CRITERIA_EVANS_DESCRIPTION: {
    ko: "Evans 기준: PRR ≥ 2, χ² ≥ 4, 동시 보고 건수 ≥ 3",
    en: "Evans criteria: PRR ≥ 2, χ² ≥ 4, co-occurrence ≥ 3",
  },
  SAFETY_FAERS_CRITERIA_CUSTOM_PRR_THRESHOLD_LABEL: { ko: "PRR 임계값", en: "PRR threshold" },
  SAFETY_FAERS_CRITERIA_CUSTOM_ROR_THRESHOLD_LABEL: { ko: "ROR 임계값", en: "ROR threshold" },
  SAFETY_FAERS_CRITERIA_CUSTOM_CHI_SQUARE_THRESHOLD_LABEL: { ko: "χ² 임계값", en: "χ² threshold" },
  SAFETY_FAERS_CRITERIA_CUSTOM_CASE_COUNT_THRESHOLD_LABEL: { ko: "최소 보고 건수", en: "Min. case count" },
  SAFETY_FAERS_CRITERIA_MET: { ko: "기준 충족", en: "Signal met" },
  SAFETY_FAERS_CRITERIA_NOT_MET: { ko: "기준 미충족", en: "Signal not met" },

  SAFETY_FAERS_COMPARISON_PANEL_TITLE: { ko: "FAERS 비교 분석", en: "FAERS Comparison" },
  SAFETY_FAERS_COMPARISON_AUTO_SNAPSHOT_NOTICE: {
    ko: "첫 진입 시 자동으로 스냅샷이 생성됩니다. 이미 저장된 결과는 재사용됩니다.",
    en: "A snapshot is created automatically on first access. Existing results are reused.",
  },
  SAFETY_FAERS_COMPARISON_CRITERIA_HEADER: { ko: "현행 판정 기준", en: "Current Criteria" },
  SAFETY_FAERS_COMPARISON_TABLE_INTERNAL_HEADER: { ko: "내부", en: "Internal" },
  SAFETY_FAERS_COMPARISON_TABLE_FAERS_HEADER: { ko: "FAERS", en: "FAERS" },
  SAFETY_FAERS_COMPARISON_TABLE_REPORT_COUNT: { ko: "동시 보고 건수 (Drug ∩ Event)", en: "Co-occurrence Reports (Drug ∩ Event)" },
  SAFETY_FAERS_COMPARISON_TABLE_PRR: { ko: "PRR", en: "PRR" },
  SAFETY_FAERS_COMPARISON_TABLE_ROR: { ko: "ROR", en: "ROR" },
  SAFETY_FAERS_COMPARISON_TABLE_CHI_SQUARE: { ko: "χ²", en: "χ²" },
  SAFETY_FAERS_COMPARISON_HISTORY_TITLE: { ko: "배치별 추이", en: "Batch History" },
  SAFETY_FAERS_COMPARISON_HISTORY_EMPTY: { ko: "배치별 추이 데이터가 없습니다.", en: "No batch history available." },
  SAFETY_FAERS_COMPARISON_HISTORY_BATCH_LABEL: { ko: "배치 #{batch}", en: "Batch #{batch}" },

  SAFETY_FAERS_SIGNAL_CHECK_PANEL_TITLE: { ko: "FAERS 시그널 체크", en: "FAERS Signal Check" },
  SAFETY_FAERS_SIGNAL_CHECK_MODE_MAPPED: { ko: "Profile 매핑 약물", en: "Profile mapped products" },
  SAFETY_FAERS_SIGNAL_CHECK_MODE_DIRECT: { ko: "직접 입력", en: "Direct search" },
  SAFETY_FAERS_SIGNAL_CHECK_MAPPED_PRODUCT_LABEL: { ko: "매핑 약물 선택", en: "Select mapped product" },
  SAFETY_FAERS_SIGNAL_CHECK_DIRECT_SEARCH_PLACEHOLDER: { ko: "외부 약물명 검색 (2자 이상)", en: "Search external drug (2+ chars)" },
  SAFETY_FAERS_SIGNAL_CHECK_DIRECT_SEARCH_EMPTY: { ko: "검색 결과가 없습니다.", en: "No results found." },
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_REACTION: { ko: "이상반응", en: "Reaction" },
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_REPORT_COUNT: { ko: "보고 건수", en: "Report Count" },
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_PRR: { ko: "PRR", en: "PRR" },
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_ROR: { ko: "ROR", en: "ROR" },
  SAFETY_FAERS_SIGNAL_CHECK_TABLE_CHI_SQUARE: { ko: "χ²", en: "χ²" },
  SAFETY_FAERS_SIGNAL_CHECK_CRITERIA_COLUMN: { ko: "신호 판정", en: "Signal" },
  SAFETY_FAERS_SIGNAL_CHECK_RESULT_EMPTY: {
    ko: "검색 결과가 없습니다. 약물을 선택하거나 검색어를 입력하세요.",
    en: "No results. Select a product or enter a search term.",
  },
  SAFETY_FAERS_SIGNAL_CHECK_SAVE_BUTTON: { ko: "저장", en: "Save" },
  SAFETY_FAERS_SIGNAL_CHECK_SAVE_SUCC: { ko: "시그널 체크 결과가 저장되었습니다.", en: "Signal check result saved." },
  SAFETY_FAERS_SIGNAL_CHECK_HISTORY_TITLE: { ko: "저장된 체크 결과", en: "Saved Results" },
  SAFETY_FAERS_SIGNAL_CHECK_HISTORY_EMPTY: { ko: "저장된 체크 결과가 없습니다.", en: "No saved results." },
  SAFETY_FAERS_SIGNAL_CHECK_DRAWER_TRIGGER: { ko: "FAERS 시그널 체크", en: "FAERS Signal Check" },

  SAFETY_FAERS_ERROR_EXTERNAL_FETCH_FAILED: {
    ko: "외부 데이터 조회에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    en: "Failed to fetch external data. Please try again later.",
  },
  SAFETY_FAERS_ERROR_GENERIC_RETRY: { ko: "오류가 발생했습니다. 다시 시도해 주세요.", en: "An error occurred. Please try again." },

  SAFETY_FAERS_USER_JUDGMENT_DISCLAIMER: {
    ko: "본 결과는 참고용이며, 최종 안전성 판단은 전문가의 임상적 판단에 따릅니다.",
    en: "These results are for reference only. Final safety assessment requires expert clinical judgment.",
  },
};

MvnCodeInitiate(SAFETY_FAERS_LANG);
